import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../css/navbar.css";

function CustomNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isMenuOpen ? 'navbar-scrolled' : ''}`}>
        <div className='nav-brands'>
         <Link to="/">
          <img
            className="brand"
            src="/images/egeastern-logo.png"
            alt="Eastern for Trading Company Logo"
          />
         </Link>

                  <img
            className="brand"
            src="/images/fuji-logo.png"
            alt="Fuji Oil Asia Logo"
          />
        </div>

      <div className="navbar-container">
<div />
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link className="navLink" to="/" onClick={closeMenu}>
            Home
          </Link>

          <Link className="navLink" to="/about" onClick={closeMenu}>
            About
          </Link>

          <Link className="navLink" to="/products" onClick={closeMenu}>
            Products
          </Link>

          <Link className="navLink" to="/contact" onClick={closeMenu}>
            Contact
          </Link>
        </div>

        <div
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

      </div>
    </nav>
  );
}

export default CustomNavbar;